import { useState } from "react";
import { useRouter } from "next/router";
import { useAuthContext } from "../../contexts/auth";

import { updateQueryString } from "../../util/url";

// @material-ui/core components
import { makeStyles } from "tss-react/mui";

// core components
import Button from "../CustomButtons/Button.js";
import Image from "next/image.js";

// sections for this page
import ForumsModal from "../ForumsModal/ForumsModal.js";
import ForumsTopicAddPost from "../ForumsTopicAddPost/ForumsTopicAddPost.js";
import ForumsMeetApprenticesPanel from "../ForumsMeetApprenticesPanel/ForumsMeetApprenticesPanel.js";

// local assets
import noPostsIcon from "../../public/img/forums/icons/noPostsIcon.png";

import styles from "../../styles/jss/nextjs-material-kit/pages/forumsStyle.js";

const useStyles = makeStyles()(styles);

export default function ForumsNoTopics(props) {
    const { classes, cx } = useStyles();
    const router = useRouter();
    const { auth } = useAuthContext();
    const data = props.data;

    const [textEditorOpen, setTextEditorOpen] = useState(false);

    const openTextEditor = async () => {
        if (auth.user == null) {
            await router.push(updateQueryString(updateQueryString(router.asPath, "login", null), "redirectUrl", router.asPath));
        } else {
            setTextEditorOpen(true);
        }
    }

    const closeTextEditor = () => {
        setTextEditorOpen(false);
    }

    return (
        <>
        <div className={classes.mobileTopicsContainer}>
        {data?.category?.guestPosters?.length > 0 &&
        <div
        className={cx(
          classes.topicCard +
            " " +
            classes.mobileView +
            " " +
            classes.apprenticeContainer
        )}
        >
        <ForumsMeetApprenticesPanel data={data} apprentices={data?.category?.guestPosters} />
        <Button
          className={cx(classes.darkButton + " " + classes.newTopicButton)}
          onClick={openTextEditor}
        >
          Ask a question
        </Button>
        </div>}
        </div>
        <div className={classes.container + " " + classes.noTopicsContainer}>
            {!textEditorOpen &&
                <div className={classes.noTopicsBox}>
                    <>
                    <Image className={classes.noTopicsIcon} src={noPostsIcon} alt={"no-posts-icon"} width={40} height={37}/>
                    <h2 className={classes.noTopicsTitle}>Be the First to Start the Conversation!</h2>
                        <p className={classes.noTopicsText}>It looks like there aren&apos;t any posts in the {data.name} community yet.
                            Why not ask a question or share your experiences to help get things started?
                        </p>
                    </>
                    <Button onClick={openTextEditor} className={cx(classes.darkButton + " " + classes.newTopicButton)}>Ask Question</Button>
                </div>
            }
            <ForumsTopicAddPost open={textEditorOpen} onClose={closeTextEditor} type="question" />
        </div>
        </>
    )
}

